import type {
  HTMLAttributes,
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

export interface FieldProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  hint?: ReactNode;
  error?: string;
  htmlFor?: string;
  children: ReactNode;
}

export function Field({ label, hint, error, htmlFor, children, className, ...rest }: FieldProps) {
  const hintCls = error ? "fd-hint fd-hint--error" : "fd-hint";
  const hintContent: ReactNode = error ?? hint;
  return (
    <div className={["fd-field", className].filter(Boolean).join(" ")} {...rest}>
      {label && (
        <label className="fd-label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {hintContent && <span className={hintCls}>{hintContent}</span>}
    </div>
  );
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export function Input({ error, className, ...rest }: InputProps) {
  const cls = ["fd-input", error && "fd-input--error", className].filter(Boolean).join(" ");
  return <input className={cls} {...rest} />;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

export function Select({ error, className, children, ...rest }: SelectProps) {
  const cls = ["fd-select", error && "fd-input--error", className].filter(Boolean).join(" ");
  return (
    <select className={cls} {...rest}>
      {children}
    </select>
  );
}

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export function Textarea({ error, className, ...rest }: TextareaProps) {
  const cls = ["fd-textarea", error && "fd-input--error", className].filter(Boolean).join(" ");
  return <textarea className={cls} {...rest} />;
}

export interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {}

export function Switch({ className, ...rest }: SwitchProps) {
  return (
    <label className={["fd-switch", className].filter(Boolean).join(" ")}>
      <input type="checkbox" {...rest} />
      <span className="fd-switch__slider" />
    </label>
  );
}
